export const ENCOUNTER_ADDENDUM_LABELS = {
  section: "Addendum",
  addedBy: "Added by",
  on: "on",
  at: "at",
  signatureAlt: "addendum signature",
  placeholder: "-",
} as const;

export const ENCOUNTER_ADDENDUM_SIGNATURE_SIZE_PX = 120;
